module.exports = __webpack_public_path__ + "static/media/persona.6f148da3.svg";